import React from 'react';
import { motion } from 'framer-motion';
import { AppStoreButton } from './AppStoreButton';
import { PlayStoreButton } from './PlayStoreButton';
export function HeroSection() {
  return <section className="bg-croon-purple pt-28 pb-20 px-6 flex flex-col items-center overflow-hidden" data-id="element-45" data-mp="23vbcz3k3y3ph">
      <div className="max-w-4xl mx-auto text-center" data-id="element-46" data-mp="28tv21ctzzvm2">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight" data-id="element-47" data-mp="28ueggjkfw1vc">
          Turn your inspiration into real songs
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col items-center justify-center mb-10" data-id="element-48" data-mp="2rr5yyqs5qcyc">
          <div className="flex items-center gap-3 text-yellow-400 mb-2" data-id="element-49" data-mp="2begjpwq5fvxk">
            <span className="text-2xl" data-id="element-50" data-mp="2p5blyq657es6">🏆</span>
            <div className="text-center" data-id="element-51" data-mp="2p63j45fe1kkk">
              <div className="text-lg md:text-xl font-bold mb-1" data-id="element-52" data-mp="2p76aeegmhp10">
                Best AI Music Generator
              </div>
              <div className="flex gap-1 justify-center" data-id="element-53" data-mp="2z2ztyhsreisa">
                {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-5 h-5 fill-current" viewBox="0 0 20 20" data-id="element-54" data-mp="2u57rwuyehgad">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-55" data-mp="335385e6tc1h9" />
                  </svg>)}
              </div>
            </div>
            <span className="text-2xl" data-id="element-56" data-mp="3dt7dxpl09w30">🏆</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-wrap items-center justify-center gap-3 mb-12" data-id="element-57" data-mp="3iqfxnulsy86d">
          <AppStoreButton data-id="element-58" data-mp="jjg2dyjkhq1" />
          <PlayStoreButton data-id="element-59" data-mp="5c2sv8pen8ts" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="flex justify-center" data-id="element-60" data-mp="5de8c5s7q50q">
          <img src="https://cdn.magicpatterns.com/uploads/j8zKD4vxdrh9DVhpvDt3oQ/0x0ss_(26).png" alt="Croon App Hero" className="w-full max-w-[220px] md:max-w-[260px] h-auto rounded-[2rem] shadow-xl" data-id="element-61" data-mp="jaazk8c8toi5" />
        </motion.div>
      </div>
    </section>;
}